<template>
  <div
    v-editable="blok"
    class="component-hero-video -z-10 grid min-h-[min(34rem,calc(100dvh-18rem))] w-full flex-col items-start justify-start gap-x-4 !px-0 pt-8 tablet:mt-8 tablet:grid-cols-2 tablet:items-center tablet:pt-0 desktop:grid-cols-3 desktop:gap-x-8"
  >
    <div class="flex flex-col tablet:order-last desktop:col-span-2">
      <storyblok-component v-if="blok.video.length" :blok="blok.video[0]" @play="played = true" />
      <member-badge
        class="z-10 -mb-10 ml-auto mr-2 mt-4 transition-[transform,opacity] tablet:mb-0"
        :class="
          played ? 'pointer-events-none opacity-0 tablet:pointer-events-auto tablet:translate-y-0 tablet:opacity-100' : '-translate-y-10'
        "
      />
    </div>
    <hero-card
      v-editable="blok"
      :blok="blok"
      :text="text"
      :headline="blok.headline"
      :overline="overline"
      :link="{ text: blok.buttonText, url: blok.buttonLink }"
      class="col-span-1 my-8 !w-full tablet:mt-0"
    />
  </div>
</template>

<script setup lang="ts">
import type { HeroVideoStoryblok } from "~/storyblok-component-types"

const props = defineProps<{ blok: HeroVideoStoryblok; }>()

const text = renderRTF(props.blok?.text)
const overline = renderRTF(props.blok?.overline)

const played = ref(false)
</script>
